import Flickity from 'vue-flickity';
import SlideProjectBigImage from './SlideProjectBigImage'
import SlideProjectTexts from './SlideProjectTexts'
import SlideProjectLogoOnWhite from './SlideProjectLogoOnWhite'

let autoplayTime = 6000;
export default {
  name: 'sliders-on-main',
  components: {
    Flickity,
    SlideProjectBigImage,
    SlideProjectTexts,
    SlideProjectLogoOnWhite
  },
  data () {
    return {
      flickityOptionsBigImage: {
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        autoPlay: autoplayTime,
        pauseAutoPlayOnHover: false,
        selectedAttraction: 0.02,
        friction: 0.28,
        draggable: false,
      },
      flickityOptionsTexts: {
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        autoPlay: autoplayTime,
        pauseAutoPlayOnHover: false,
        selectedAttraction: 0.02,
        friction: 0.28,
        rightToLeft: true,
        draggable: false,
      },
      flickityOptionsLogoOnWhite: {
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        autoPlay: autoplayTime,
        pauseAutoPlayOnHover: false,
        selectedAttraction: 0.02,
        friction: 0.28,
        rightToLeft: true,
        draggable: false,
      },
      isRootHover: false,
    }
  },
  methods:{
    processMouseEnter(){
      this.isRootHover = true;
    },
    processMouseLeave(){
      this.isRootHover = false;
    },
  }
}



// WEBPACK FOOTER //
// ./src/includes/SlidersOnMain.js